<dp-date-picker (onSelect)="onChange($event)"
                (open)="onOpen()"
                [config]="config"
                [mode]="mode"
                [disabled]="disabled"
                [displayDate]="realDate"
                [ngModel]="realDate"
                [placeholder]="getPlaceholder()">
</dp-date-picker>
